export const imageDimensions = { width: 1240, height: 1754 }
